<div class="change-simple-order dropdown-content-root">
	<div class="dropdown-title">
		<h4 class="title">{{ 'changeOrder.title' | translate }}</h4>
		<tui-icon
			class="close-icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="details">
		<div class="detail">
			<span class="title">{{ 'changeOrder.ticker' | translate }}</span>
			<span class="value">{{ order()?.symbol }}</span>
		</div>

		<div class="detail">
			<span class="title">{{ 'changeOrder.operation' | translate }}</span>
			<span
				class="value"
				highlight
				[isPositive]="order()?.side === orderSideEnum.BUY"
				[isNegative]="order()?.side === orderSideEnum.SELL"
				>{{ 'changeOrder.side.' + order()?.side | translate }}</span
			>
		</div>

		<div class="detail">
			<span class="title">{{ 'changeOrder.orderType' | translate }}</span>
			<span class="value">{{ order() | titleOrderType: true }}</span>
		</div>

		<div class="detail">
			<span class="title">{{ 'changeOrder.orderDuration' | translate }}</span>
			<span class="value">{{ order()?.time_in_force | uppercase }}</span>
		</div>

		@if (isStopPriceVisible()) {
			<div class="detail">
				<span class="title">{{ 'changeOrder.stopPrice' | translate }}</span>
				<span class="value">{{ order()?.stop_price | price }}</span>
			</div>
		}

		@if (isLimitPriceVisible()) {
			<div class="detail">
				<span class="title">{{ 'changeOrder.limitPrice' | translate }}</span>
				<span class="value">{{ order()?.limit_price | price }}</span>
			</div>
		}

		@if (isTrailingStopVisible()) {
			<div class="detail">
				<span class="title">{{
					(trailIsPercent() ? 'changeOrder.trailPercent' : 'changeOrder.trailPrice') | translate
				}}</span>
				<span class="value">{{
					trailIsPercent() ? (order()?.trail_percent | percent) : (order()?.trail_price | price)
				}}</span>
			</div>
		}

		<div class="detail">
			<span class="title">{{ 'changeOrder.quantity' | translate }}</span>
			<span class="value">{{ order()?.qty | quantity }}</span>
		</div>
	</div>

	@if (form) {
		<form
			class="form"
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
		>
			@if (isStopPriceVisible()) {
				<app-order-price-input
					label="changeOrder.stopPrice"
					[control]="form.get('stop_price')"
				/>
			}

			@if (isLimitPriceVisible()) {
				<app-order-price-input
					label="changeOrder.limitPrice"
					[control]="form.get('limit_price')"
				/>
			}

			@if (isTrailingStopVisible()) {
				<app-order-price-input
					[label]="(trailIsPercent() ? 'changeOrder.trailPercent' : 'changeOrder.trailPrice') | translate"
					[control]="form.get('trail')"
					[icon]="trailIsPercent() ? '@tui.percent' : '@tui.dollar-sign'"
					[step]="trailIsPercent() ? 0.1 : 0.01"
				/>
			}

			<div class="order-summary">
				<div class="item">
					<p class="label">{{ 'changeOrder.approximateSum' | translate }}:</p>
					<span class="value">{{ approximateSum() | price }}</span>
				</div>
				<div class="item">
					<p class="label">{{ 'changeOrder.availableFunds' | translate }}:</p>
					<span class="value">{{ alpacaAccount()?.buying_power ?? 0 | price }}</span>
				</div>
			</div>

			<app-button
				appearance="primary"
				size="m"
				type="submit"
				[isLoading]="isLoading()"
			>
				{{ 'changeOrder.confirm' | translate }}
			</app-button>
		</form>
	}
</div>
